export default __webpack_public_path__ + "static/media/Bengali_ef_2.c151352d.mp3";